import styled, { keyframes, css } from 'styled-components'

const glow = keyframes`
  from {
    background-color: var(--white);
  }

  to {
    background-color: #ffe799;
  }

`
const Input = styled.input.attrs({ className: 'form-control' })`
  box-shadow: none !important;
  background: var(--white);
  border-right: none;

  ${(props) =>
    props.highlight &&
    css`
      animation: ${glow} 400ms ease-out infinite alternate;
    `}

  &::placeholder {
    color: #415b65;
  }

  &:focus {
    border-right: none;
  }

  & + .input-group-addon {
    outline: 0;
    background: var(--white);
    border-left: none;
    color: var(--main-color);

    ${(props) =>
      props.highlight &&
      css`
        animation: ${glow} 400ms ease-out infinite alternate;
      `}

    .fa {
      position: relative;
      top: 0px;
      font-size: 16px;
    }
  }
`

export default Input
